import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MainRoute } from "@routes/MainRoute";
import { AuthProvider } from "providers/AuthProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/style.css";
import "./i18n/i18n";
import "./sentry.config";
import { useState } from "react";

export const CoreProvider: React.FC<any> = () => {
  const [queryClient] = useState(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
        },
      },
    });
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <MainRoute />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(<CoreProvider />);
